import { createSlice } from '@reduxjs/toolkit';
import {
    fetchUsers,
    addUser,
    updateUser,
    deleteUser,
    getUserProfile,
    updateUserProfile,
} from '../thunks/usersThunks.js';

const initialState = {
    list: [],
    maxPageNumber: 0,
    loading: false,
    error: '',
    profile: {},
    profileLoading: false,
};

const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsers.fulfilled, (state, action) => {
                const { list, maxPageNumber } = action.payload;
                state.list = list;
                state.maxPageNumber = maxPageNumber;
                state.loading = false;
            })
            .addCase(addUser.fulfilled, (state, action) => {
                state.list.unshift(action.payload);
                state.loading = false;
            })
            .addCase(updateUser.fulfilled, (state, action) => {
                const updatedUser = action.payload;
                state.list = state.list.map((u) => (u.id === updatedUser.id ? { ...u, ...updatedUser } : u));
                state.loading = false;
            })
            .addCase(deleteUser.fulfilled, (state, action) => {
                const { id } = action.payload;
                state.list = state.list.filter((u) => u.id !== id);
                state.loading = false;
            })
            .addCase(getUserProfile.fulfilled, (state, action) => {
                state.profile = action.payload;
                state.profileLoading = false;
            })
            .addCase(updateUserProfile.fulfilled, (state, action) => {
                state.profile = action.payload;
                state.profileLoading = false;
            })
            .addMatcher(
                (action) => [getUserProfile.pending.type, updateUserProfile.pending.type].includes(action.type),
                (state) => {
                    state.profileLoading = true;
                    state.error = null;
                },
            )
            .addMatcher(
                (action) => [getUserProfile.rejected.type, updateUserProfile.rejected.type].includes(action.type),
                (state, action) => {
                    state.profileLoading = false;
                    state.error = action.error || action.error?.message;
                },
            )
            .addMatcher(
                (action) =>
                    [
                        fetchUsers.pending.type,
                        addUser.pending.type,
                        updateUser.pending.type,
                        deleteUser.pending.type,
                    ].includes(action.type),
                (state) => {
                    state.loading = true;
                    state.error = null;
                },
            )
            .addMatcher(
                (action) =>
                    [
                        fetchUsers.rejected.type,
                        addUser.rejected.type,
                        updateUser.rejected.type,
                        deleteUser.rejected.type,
                    ].includes(action.type),
                (state, action) => {
                    state.loading = false;
                    state.error = action.error || action.error?.message;
                },
            )
            .addDefaultCase((state) => state);
    },
});

export default usersSlice.reducer;
